export interface IOrderDetails {
    customer: {
        name: string;
        email: string;
        phone: string;
        pincode?: string;
    };
    device: {
        category: string;
        delivery_date: number[];
        manufacturer_warranty?: {
            years: number;
            months: number;
            days: number;
        };
        name: string;
        order_id: string;
        price: number;
        purchase_date: string;
        serial_number: string;
        promoter_id: string;
    };
    document_urls: {
        invoice: string;
        imei: string;
    };
    ekey: string;
    order_communication: boolean;
    payment_details: {
        amount: number;
        timestamp: string;
        user_id: string;
        user_name: string;
    };
    plan: {
        partner: string;
        plan_id: string;
        benefits: string[];
        insurance_program_id: string;
        plan_name: string;
        plan_purchase_date: number[];
        premium: number;
        promo_name: string;
        purcahse_date: string;
        plan_category: string;
        commission_split: CommisionSplit;
        discount_split: DiscountSplit;
        settle_with_acko: number;
        commission_amount: number;
        discount_amount: number;
        emi_enabled: boolean;
        emi_selected: boolean;
        payment_mode: 'FULL' | 'EMI';
    };
    policy_communication: boolean;
    status: string;
}

export interface CommisionSplit {
    commission_id: string;
    commission: Commision[];
}

export interface DiscountSplit {
    discount_id: string;
    discount: Discount[];
}

export interface Commision {
    role: string;
    amount: number;
}

export interface Discount {
    role: string;
    amount: number;
}

export enum PaymentOptionType {
    DEALER_PAYMENT = 'dealer_payment',
    CUSTOMER_PAYMENT = 'customer_payment',
    DEALER_WALLET_PAYMENT = 'dealer_wallet_payment',
}

export interface IPaymentOption {
    type: PaymentOptionType;
    applicable: boolean;
    name: string;
}

export interface IPaymentOptionsResponse {
    statusCode: number;
    data: IPaymentOption[];
    status: boolean;
    errorMessage?: string;
}
